// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","167":"detail","177":"home","443":"about","505":"case","631":"contact","834":"partner"}[chunkId] + "." + {"18":"a490ab37","167":"824d0432","177":"ddd8dcda","443":"5b67f73e","505":"e31d19f1","631":"6267430a","834":"743017df"}[chunkId] + ".css";
};